import { graphQLBase } from '..'

const ShareAPI = {
  getNotePublicToken: graphQLBase(
    `
    query showPublicNoteById($noteId: ID!) {
      showPublicNoteById(noteId: $noteId) {
        title
        publicShareToken
        channelId
        publiclySharedAt
        parentNote {
          id
        }
      }
    }
  `,
    ({ showPublicNoteById }) => showPublicNoteById
  ),
}

export default ShareAPI
